"use client";

import { type ReactNode, useEffect } from "react";
import {
  refreshServiceWorkerOnForeground,
  setupAppLifecycle,
  subscribeForeground,
} from "@/lib/app-lifecycle";

/**
 * Installs the global app-lifecycle bridge once on the client. Mounted inside
 * the QueryProvider so the focusManager wiring is active app-wide.
 */
export function AppLifecycleProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    setupAppLifecycle();

    return subscribeForeground(() => {
      if (!navigator.onLine) return;

      refreshServiceWorkerOnForeground();
    });
  }, []);

  return <>{children}</>;
}
